import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Select } from "@mui/material";
import FormField from "./FormField";

function FormSelect(props) {
  const multiple = useMemo(() => {
    return props.multiple ?? false;
  }, [props.multiple]);
  return (
    <FormField
      Field={Select}
      defaultValue={props.defaultValue}
      fieldChildren={props.options}
      fieldProps={({ value }) => {
        props.onSelect ? props.onSelect(value) : null;
        return {
          value: value ?? (multiple ? [] : "") ?? "",
          multiple: multiple,
        };
      }}
      {...props}
    />
  );
}

FormSelect.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),

  options: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
  nullable: PropTypes.bool,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
};

export default FormSelect;
